// extracted by mini-css-extract-plugin
export default {"elementsPosition":"ManagementPageHeader_elementsPosition__pAehy"};